<template>
    <header class="position-relative vh-100">
      <div class="bg-company-img header-section vh-100">
        <div class="container">
          <div class="row justify-content-center brand-section vh-100">
            <p class="col-12 col-md-8 col-xl-6 text-center company-image"><img src="@/assets/img/bba/logo.png" alt="bba"></p>
            <h1 class="col-12 col-lg-10 col-xl-8 text-center second-typo">{{ $t('formation.home.headTitle') }}</h1>
            <h2 class="col-12 col-lg-9 col-xl-12 text-center">{{ $t('formation.home.subTitle') }}</h2>
            <h3 class="col-md-10 col-lg-8">
              {{ $t('formation.home.text_1') }}<br />
              {{ $t('formation.home.text_2') }}
            </h3>
            <div class="col-8 text-center scroll-indicator">
              <span @click="scrollTo">{{ $t('formation.home.scrollText') }}</span>
              <span @click="scrollTo" class="chevron"><i class="fas fa-chevron-down"></i></span>
            </div>
          </div>
        </div>
      </div>
    </header>
</template>
<script>
export default {
  methods: {
    scrollTo () {
      this.$root.$emit('eventing')
    }
  }

}
</script>
<style lang="scss" scoped>
.chevron{
  position: relative;
  animation: glissement 1s infinite;
  animation-direction: alternate;
}
@keyframes glissement {
  from {
    top:0px;
  }
  to{
    top:20px;
  }
}
.scroll-indicator span {
      display: block;
}
.header-section h3{
    display: none;
}
.scroll-indicator > span:hover{
  cursor: pointer;
}
.scroll-indicator{
    color: #E65011;
    font-size: 1.7rem;
    font-weight: 600;
    padding-top: 9rem;
    padding-bottom: 2rem;
}
.second-typo{
    font-family: 'prata', serif;
    color:#1A2050 ;
    font-weight: bold;
}
.company-image img{
    width: 100%;
}
.bg-company-img{
    background-image: url('~@/assets/img/bba/loginBba2.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}
.brand-section .company-image {
  padding-top: 12rem; }
.brand-section h1 {
  padding-top: 2rem;
  font-size: calc(1.2rem + 1.5vw); }
.brand-section h2 {
  padding-top: 5rem;
  font-size: calc(.9rem + .9vw); }
.brand-section h3 {
  padding-top: 5rem; }

@media (min-width: 576px) {
    .container{
        max-width: 540px;
    }
}
@media (min-width: 768px) {
  .header-section h3{
    display: block;
  }
  .container{
    max-width: 720px;
  }
  .brand-section .company-image {
    padding-top: 10rem; }
  .brand-section h1 {
    padding-top: 2rem;
    font-size: calc(1.2rem + 1.5vw); }
  .brand-section h2 {
    padding-top: 1rem;
    font-size: calc(1rem + .9vw); }
  .brand-section h3 {
    padding-top: 5rem;
    font-size: calc(.9rem + .6vw); }
}
@media (min-width: 992px) {
    .container{
        max-width: 960px;
    }
    .brand-section h3{
      padding-top: 2rem;
    }
    .scroll-indicator{
      padding-top: 0;
    }

}
@media (min-width: 1080px) {
  .brand-section .company-image {
    padding-top: 7rem;
  }
  .brand-section h3{
    padding-top: 2rem;
  }
  .scroll-indicator{
    padding-top: 1rem;
  }

}
@media (min-width: 1200px) {
  .container{
    max-width: 1140;
  }
  /*
  .brand-section .company-image {
    padding-top: 7rem; }
  .brand-section h1 {
    padding-top: 2rem;
    font-size: calc(1.2rem + 1.5vw); }
  .brand-section h2 {
    padding-top: 1rem;
    font-size: calc(1rem + .9vw); }
  .brand-section h3 {
    padding-top: 5rem;
    font-size: calc(.8rem + .6vw); }

  .scroll-indicator {
    padding-top: 2rem;
    padding-bottom: 0; }
  */
}
@media (min-width: 1400px) {
    .container {
        max-width: 1320px;
    }
  /*
  .brand-section h1 {
    padding-top: 1rem; }
  .brand-section h2 {
    padding-top: 1.5rem; }
  .brand-section h3 {
    padding-top: 5rem; }
  */
  .scroll-indicator {
    font-size: 2rem;
    font-weight: 600;
    padding-top: 4rem; }

}
@media only screen and (max-height:600px) and (orientation: landscape) {
  .header-section h3{
    display: none;
  }
  .brand-section .company-image{
    padding-top: 1rem;
  }
  .scroll-indicator{
    display: none;
  }
}

</style>
